var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-sticker",
    width: 19,
    height: 19,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABpUlEQVQ4jZWUvSuGYRTGfx5KEhmkGCzKQJFF7P4CsWA1GCTlY3oJC1EGJYOP8rWIxWKQwaLYlNVgUZLekmTw0aXrye3teR+va3mec59zrs65zrnvorbzJhJQBfQBXUA7UAMsA5NJwTFKcuxiYAzIAOU5vnHgGtjLRxYF/xXACTBvontgBXi1vwjYBvr/IlNFR27rA5gGGoBFoMwxZ47PSxiTjQVEvcCsK3oJYgeB4zTCyGJnbM+4whhPblfoAHrSCCNPLdZoMaH6Q38nXHlewsjtCQeB2CGWfd4KbPk8kVBGswMukkQFboFh/w8AV9Z1JBjKDrBQEkzrMQ+ZsAF8AqtAC7Cb49fajEZBa9UpZMIm0AisBUMhyH8Q2Y2Nzj/IhDtgCKgDKoF6YN2+S5Gd2ugNWi4Ez5amx7GnItv3ctb6/v0H485T/r7IssCcCXSNugsk63Y8zs/G12nJ7Ubet6mUlnUuv+JimZRP+J7p1Ygvu6CJKUH7J200bQ1J2qq1b51cofT7RSakvWchpJFaU0XvsaOQl1Y3pBR48xqpGg1NWv8A+AKip2FeDrPGeAAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSticker);
export default __webpack_public_path__ + "static/media/ico_sticker.211b6269.svg";
export { ForwardRef as ReactComponent };